module.exports = __webpack_public_path__ + "img/milestone__2009.94ae42ca.jpg";